import {
    Box,
    Typography,
    Button,
    Grid,
    Container,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { isIncludedByBoardBasis } from "../utils/boardBasis";

const FiltraProdotto = ({
    prodottiFiltratiPerNome,
    selectedTable,
    handleAddProduct,
    activeBoardBasis,
}) => {

    const { t } = useTranslation();
    const theme = useTheme();

    const productLength = prodottiFiltratiPerNome?.length;

    return (
        <Container
            sx={{
                padding: 1,
                overflow: "auto",
                height: "100%",
                minHeight: 0,
                flex: 1,
            }}
        >
            {productLength < 1 ? (
                <Box key="NoCat">
                    <Typography>{t("NoCategory")}</Typography>
                </Box>
            ) : (
                <Grid container spacing={1}>
                    {prodottiFiltratiPerNome?.map((p, index) => {
                        const [colSize_xs, colSize_sm, colSize_md, colSize_lg, colSize_xl] = [6, 6, 6, 4, 4];
                        const included = isIncludedByBoardBasis(p, activeBoardBasis);

                        return (
                            <Grid item key={index} xs={colSize_xs} sm={colSize_sm} md={colSize_md} lg={colSize_lg} xl={colSize_xl}>
                                <Button
                                    height="104px"
                                    fullWidth
                                    disabled={!selectedTable}
                                    variant="outlined"
                                    onClick={() => { handleAddProduct(p); }}
                                    title={p.name}
                                    sx={{
                                        height: { xs: 84, sm: 88, md: 92, lg: 98 },
                                        width: "100%",
                                        maxWidth: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        textTransform: "none",
                                        overflow: "hidden",
                                        ...theme.checkout.product_button,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            minWidth: 0,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 0.5,
                                        }}
                                    >
                                        <Typography
                                            fontSize={14}
                                            sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                lineHeight: 1.2,
                                                textAlign: "center",
                                                maxWidth: "100%",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {p.name}
                                        </Typography>
                                        <Typography sx={{ fontWeight: 800 }}>
                                            {included
                                                ? t("boardBasis.included", { defaultValue: "Included" })
                                                : `EUR ${Number(p.price || 0).toFixed(2)}`}
                                        </Typography>
                                    </Box>
                                </Button>
                            </Grid>
                        );
                    })}
                </Grid>
            )}
        </Container>
    );
};

export default FiltraProdotto;
